/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  createCampaignAnalysisRequestSchema,
  createCampaignAnalysisResponseSchema,
} from '../campaign-schema';

export const createCampaignAnalysisPathSchema = z.object({
  campaignId: z.string(),
});

export const createCampaignAnalysisRequestBodySchema =
  createCampaignAnalysisRequestSchema;

export const createCampaignAnalysisOperationResponseSchema =
  createCampaignAnalysisResponseSchema;

export type CreateCampaignAnalysisInput = {
  path: z.input<typeof createCampaignAnalysisPathSchema>;
  body: z.input<typeof createCampaignAnalysisRequestBodySchema>;
  signal?: AbortSignal;
};

export async function createCampaignAnalysis({
  path,
  body,
  signal,
}: CreateCampaignAnalysisInput): Promise<
  z.infer<typeof createCampaignAnalysisOperationResponseSchema>
> {
  const parsedPath = createCampaignAnalysisPathSchema.parse(path);
  const parsedBody = createCampaignAnalysisRequestBodySchema.parse(body);

  const response = await socialApiClient.post(
    `campaigns/${parsedPath.campaignId}/analyses`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
  return createCampaignAnalysisOperationResponseSchema.parse(
    await response.json(),
  );
}
